import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  path: any = "";

  constructor(
    private route: ActivatedRoute
  ) {

    switch (route.routeConfig.path) {
      case "hogar":
        this.path = "hogar"; 
        break;

      case "tecnologia":
      case "tecnologia-gracias":
      case "tecnologia-nps":
      case "tecnologia-unsuscribe":
        this.path = "tecnologia"; 
        break;
    }

    
  }

  ngOnInit() {
    
  }

}
